module.exports = __webpack_public_path__ + "media/integrations/integrations-f260c2ea.svg";